module.exports = __webpack_public_path__ + "img/tickets-v2.51ecfba5.svg";